import React, { useRef, useEffect, useState } from "react";
import Slider from "react-slick";
import styles from './style.module.scss';
import { getImagePath } from '../getImagePath';
import MobileSlider from './MobileSlider';
import Scroll from 'react-scroll';
import { Waypoint } from 'react-waypoint';
import ResourceLinks from '../../Series/ResourceLinks';

// Waypoint 配置
const waypointOption = {
    topOffset: '30%',
    bottomOffset: '30%',
};



    function DataResourcesSection(props) {
        const [activeSection, setActiveSection] = useState(null);
        const sliderRef = useRef(null);
        const [isMobile, setIsMobile] = useState(false);




        // 處理 Waypoint 進入視圖
        const handleWaypointEnter = (name) => {
            setActiveSection(name);
            
            // 如果需要通知父組件更新滾動監聽指示器，可以通過 props 傳入回調
            if (props.onSectionEnter) {
                props.onSectionEnter(name);
            }
        };




    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.matchMedia('(max-width: 768px)').matches);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

 

    return (
        <div>
              <Scroll.Element name="resource">
                <Waypoint onEnter={() => handleWaypointEnter('resource')} {...waypointOption}>
                    <section className={styles.chishangSection}>
                        <div className="container">
                            <h1 className={styles.sectiontitle}>資料來源</h1>
                            {/* 使用與莫拉克頁面相同的 ResourceLinks 組件，但調整 category 和 theme */}
                            <ResourceLinks category="chishang" theme="purple"></ResourceLinks>
                        </div>
                    </section>
                </Waypoint>
            </Scroll.Element>
        <div className={styles.container}>
            <div className={styles.notes}>
                <h4>主題圖表圖示由池上鄉公所提供</h4>
                <ul>
                    <li>註1：中央氣象署（2022）。中央氣象署地震報告。</li>
                    <li>註2：中央災害應變中心（2022）。0918池上地震災害應變處置報告第2報。</li>
                    <li>註3：楊慧敏、高振源（2022）。營建建設基金及國土永續發展基金112年度預算評估報告。</li>
                </ul>
            </div>
        </div>
    </div>
    );
}

export default DataResourcesSection;
